@if (relatedImages$ | async; as relatedImages) {
  <app-gallery [galleryItems]="relatedImages" />
}
@if (hasMoreResults$ | async) {
  <app-gallery-items-load-more (loadMore)="onLoadMore()" />
}
